/**
 * inflightTracker
 *
 * A tiny singleton to track in-flight network activity across the app.
 * This avoids timing issues where UI listeners attach after requests start.
 */
let inflightCount = 0;
const listeners = new Set();

export function getInflightCount() {
  return inflightCount;
}

export function updateInflight(delta) {
  const next = Math.max(0, inflightCount + delta);
  inflightCount = next;
  for (const listener of listeners) {
    try {
      listener(inflightCount);
    } catch (e) {
      // Listener errors should never break inflight tracking
      // eslint-disable-next-line no-console
      console.warn('inflightTracker listener error:', e);
    }
  }
}

export function subscribeInflight(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}


